"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.computePostMailDeliveryCostCents = exports.getPostMailUnitPriceCents = exports.getPostMailBaseUnitPriceCents = exports.computePostMailPaymentBreakdown = exports.getPostMailMailingClassSurchargeUnitCents = exports.getPostMailLetterUnitPriceCents = exports.getPostMailAdditionalPageCount = exports.isPostMailCustomImportMissingPages = exports.getPostMailCustomImportPageCount = exports.POST_MAIL_STRIPE_MIN_CHARGE_CENTS = exports.POST_MAIL_PCM_MAILING_CLASS_SURCHARGE_CENTS = exports.POST_MAIL_PCM_ADDITIONAL_PAGE_UNIT_PRICE_CENTS = exports.POST_MAIL_PCM_FIRST_CLASS_UNIT_PRICE_CENTS = exports.POST_MAIL_PCM_STANDARD_UNIT_PRICE_CENTS = exports.POST_MAIL_POSTGRID_UNIT_PRICE_CENTS = void 0;
const post_mail_1 = require("../enums/post-mail");
exports.POST_MAIL_POSTGRID_UNIT_PRICE_CENTS = 100;
exports.POST_MAIL_PCM_STANDARD_UNIT_PRICE_CENTS = 120;
exports.POST_MAIL_PCM_FIRST_CLASS_UNIT_PRICE_CENTS = 150;
exports.POST_MAIL_PCM_ADDITIONAL_PAGE_UNIT_PRICE_CENTS = 30;
exports.POST_MAIL_PCM_MAILING_CLASS_SURCHARGE_CENTS = exports.POST_MAIL_PCM_FIRST_CLASS_UNIT_PRICE_CENTS - exports.POST_MAIL_PCM_STANDARD_UNIT_PRICE_CENTS;
exports.POST_MAIL_STRIPE_MIN_CHARGE_CENTS = 100;
const getPostMailCustomImportPageCount = ({ contentMode, customLetterPageUrls, }) => {
    if (contentMode !== post_mail_1.PostMailContentMode.CustomImport) {
        return 1;
    }
    return customLetterPageUrls?.length ?? 0;
};
exports.getPostMailCustomImportPageCount = getPostMailCustomImportPageCount;
const isPostMailCustomImportMissingPages = ({ providerOrigin, contentMode, customLetterPageUrls, }) => providerOrigin === post_mail_1.PostMailProviderOrigin.Pcm &&
    contentMode === post_mail_1.PostMailContentMode.CustomImport &&
    !customLetterPageUrls?.length;
exports.isPostMailCustomImportMissingPages = isPostMailCustomImportMissingPages;
const getPostMailAdditionalPageCount = (pageCount) => Math.max(0, pageCount - 1);
exports.getPostMailAdditionalPageCount = getPostMailAdditionalPageCount;
const getPostMailLetterUnitPriceCents = ({ providerOrigin, }) => {
    if (providerOrigin === post_mail_1.PostMailProviderOrigin.Postgrid) {
        return exports.POST_MAIL_POSTGRID_UNIT_PRICE_CENTS;
    }
    return exports.POST_MAIL_PCM_STANDARD_UNIT_PRICE_CENTS;
};
exports.getPostMailLetterUnitPriceCents = getPostMailLetterUnitPriceCents;
const getPostMailMailingClassSurchargeUnitCents = ({ providerOrigin, mailingClass, }) => {
    if (providerOrigin !== post_mail_1.PostMailProviderOrigin.Pcm) {
        return 0;
    }
    if (mailingClass === post_mail_1.PostMailMailingClass.FirstClass) {
        return exports.POST_MAIL_PCM_MAILING_CLASS_SURCHARGE_CENTS;
    }
    return 0;
};
exports.getPostMailMailingClassSurchargeUnitCents = getPostMailMailingClassSurchargeUnitCents;
const computePostMailPaymentBreakdown = ({ recipientCount, providerOrigin, mailingClass, pageCount = 1, }) => {
    const letterUnitPriceCents = (0, exports.getPostMailLetterUnitPriceCents)({ providerOrigin });
    const mailingClassSurchargeUnitCents = (0, exports.getPostMailMailingClassSurchargeUnitCents)({ providerOrigin, mailingClass });
    const lettersSubtotalCents = letterUnitPriceCents * recipientCount;
    const mailingClassSubtotalCents = mailingClassSurchargeUnitCents * recipientCount;
    const additionalPageCount = providerOrigin === post_mail_1.PostMailProviderOrigin.Pcm ? (0, exports.getPostMailAdditionalPageCount)(pageCount) : 0;
    const additionalPageUnitPriceCents = exports.POST_MAIL_PCM_ADDITIONAL_PAGE_UNIT_PRICE_CENTS;
    const additionalPagesSubtotalCents = additionalPageCount * additionalPageUnitPriceCents * recipientCount;
    return {
        letterUnitPriceCents,
        lettersSubtotalCents,
        mailingClassSurchargeUnitCents,
        mailingClassSubtotalCents,
        additionalPageCount,
        additionalPageUnitPriceCents,
        additionalPagesSubtotalCents,
    };
};
exports.computePostMailPaymentBreakdown = computePostMailPaymentBreakdown;
const getPostMailBaseUnitPriceCents = ({ providerOrigin, mailingClass, }) => {
    if (providerOrigin === post_mail_1.PostMailProviderOrigin.Postgrid) {
        return exports.POST_MAIL_POSTGRID_UNIT_PRICE_CENTS;
    }
    if (mailingClass === post_mail_1.PostMailMailingClass.FirstClass) {
        return exports.POST_MAIL_PCM_FIRST_CLASS_UNIT_PRICE_CENTS;
    }
    return exports.POST_MAIL_PCM_STANDARD_UNIT_PRICE_CENTS;
};
exports.getPostMailBaseUnitPriceCents = getPostMailBaseUnitPriceCents;
const getPostMailUnitPriceCents = ({ providerOrigin, mailingClass, pageCount = 1, }) => {
    const baseUnitPriceCents = (0, exports.getPostMailBaseUnitPriceCents)({ providerOrigin, mailingClass });
    if (providerOrigin === post_mail_1.PostMailProviderOrigin.Postgrid) {
        return baseUnitPriceCents;
    }
    return (baseUnitPriceCents + (0, exports.getPostMailAdditionalPageCount)(pageCount) * exports.POST_MAIL_PCM_ADDITIONAL_PAGE_UNIT_PRICE_CENTS);
};
exports.getPostMailUnitPriceCents = getPostMailUnitPriceCents;
const computePostMailDeliveryCostCents = ({ recipientCount, providerOrigin, mailingClass, discountPercentage, pageCount = 1, }) => {
    const baseUnitPriceCents = (0, exports.getPostMailUnitPriceCents)({ providerOrigin, mailingClass, pageCount });
    const rawSubtotalCents = recipientCount * baseUnitPriceCents;
    const unitPriceCents = recipientCount > 0 ? Math.round(rawSubtotalCents / recipientCount) : baseUnitPriceCents;
    const subtotalCents = unitPriceCents * recipientCount;
    const deliveryCostCents = Math.round(subtotalCents * (1 - discountPercentage / 100));
    const discountAmountCents = subtotalCents - deliveryCostCents;
    const stripeFinalCents = recipientCount === 0 ? 0 : Math.max(deliveryCostCents, exports.POST_MAIL_STRIPE_MIN_CHARGE_CENTS);
    return {
        unitPriceCents,
        subtotalCents,
        discountAmountCents,
        deliveryCostCents,
        stripeFinalCents,
    };
};
exports.computePostMailDeliveryCostCents = computePostMailDeliveryCostCents;
